import { useHippoText } from '../../../hooks/useHippoText';
import WizardPagetemplate from '../../../templates/WizardPagetemplate';
import CoverableDetailsTemplate from '../../../templates/CoverableDetailsTemplate';
import { NumberField } from '@flos/react-ui';
import { useState } from 'react';
import { allCoverablesOnsaAtom } from '../../../recoil/atoms/allCoverablesOnsaAtom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { getOnsaCurrentProductSelector } from '../../../recoil/selectors/getOnsaCurrentProductSelector';
import { useUpdateCoverableInformation } from '../../../recoil/hooks/useUpdateCoverableInformation';
import { getCoverableIndex } from '../../../utils/coverablesUtil';
import type { CoverableInformationToUpdateDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';
import { useSaveCoverableInformation } from '../../../hooks/useSaveCoverableInformation';
import CallMeModal from '../../../shared_components/CallMeModal/CallMeModal';
import { carVehicleTariffGroupSelector } from '../../../recoil/selectors/carVehicleTariffGroupSelector';
import { carAgeOfPrimaryUserAtom } from '../../../recoil/atoms/carAgeOfPrimaryUserAtom';
import { track } from '../../../utils/trackingUtil';

const tariff36to38 = ['36', '37', '38'];

const CarAgeOfOldestInHousehold = ({
    goNext,
    goPrevious
}: {
    goNext: () => void;
    goPrevious: () => void;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const [coverables] = useRecoilState(allCoverablesOnsaAtom);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const { updateCoverableInformation } = useUpdateCoverableInformation();
    const { saveCoverableInformation } = useSaveCoverableInformation();
    const carCoverables = coverables.cars ?? [];
    const coverableIndex = getCoverableIndex(carCoverables, currentProduct.fixedId);
    const currentCarCoverable = carCoverables[coverableIndex];
    const vehicleTariffGroup = useRecoilValue(carVehicleTariffGroupSelector);
    const ageOfPrimaryUser = useRecoilValue(carAgeOfPrimaryUserAtom);
    const isBvrMvp78Triggered =
        !!currentCarCoverable.isInLeasing &&
        ageOfPrimaryUser < 30 &&
        tariff36to38.includes(vehicleTariffGroup ?? '');
    const [showCallMeModal, setShowCallMeModal] = useState<boolean>(isBvrMvp78Triggered);

    const [oldestInHouseholdAge, setOldestInHouseholdAge] = useState<number | undefined>(
        currentCarCoverable.ageOfOldestInHousehold
    );
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const onNext = (): void => {
        if (isBvrMvp78Triggered) {
            setShowCallMeModal(true);
            return;
        }
        setIsLoading(true);
        updateCoverableInformation({
            ageOfOldestInHousehold: oldestInHouseholdAge
        });
        const updatedCoverable: CoverableInformationToUpdateDTO = {
            car: {
                publicId: currentCarCoverable.publicId,
                fixedId: currentCarCoverable.fixedId,
                ageOfOldestInHousehold: oldestInHouseholdAge
            },
            productToUpdate: currentProduct.flavourName
        };

        void saveCoverableInformation(updatedCoverable).then(() => {
            track(`${currentProduct.flavourName}ContentCoverableInformationOldestInHousehold`, [
                {
                    ageOfOldestInHousehold: oldestInHouseholdAge
                }
            ]);
            setIsLoading(false);
            goNext();
        });
    };

    return (
        <WizardPagetemplate
            onPrevious={goPrevious}
            onNext={onNext}
            disableNext={isLoading || !oldestInHouseholdAge}
            disablePrevious={isLoading}
            isNextLoading={isLoading}
        >
            <CoverableDetailsTemplate
                header={getHippoText(
                    'DSS-COVERABLE-INFORMATION-STEP-PRIMARY-USER-OLDEST-HOUSEHOLD-HEADER'
                )}
            >
                <NumberField
                    label={getHippoText(
                        'DSS-COVERABLE-INFORMATION-STEP-PRIMARY-USER-OLDEST-HOUSEHOLD-TEXT'
                    )}
                    value={oldestInHouseholdAge?.toString()}
                    onChange={(event) => {
                        setOldestInHouseholdAge(parseInt(event.target.value));
                    }}
                    minLength={1}
                    disabled={isLoading}
                />
            </CoverableDetailsTemplate>
            {showCallMeModal && (
                <CallMeModal
                    activityCode="dss_call_request"
                    showModal={showCallMeModal}
                    closeModal={() => {
                        setShowCallMeModal(false);
                    }}
                    title={getHippoText('DSS-CALL-ME-MODAL-MVP-BVR-78-HEADER')}
                    description={getHippoText('DSS-CALL-ME-MODAL-MVP-BVR-78-SUBHEADER')}
                />
            )}
        </WizardPagetemplate>
    );
};
export default CarAgeOfOldestInHousehold;
